import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./styles/shared.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    > */}
    <App />
    {/* </BrowserRouter> */}
  </React.StrictMode>,
);

reportWebVitals();
